export default __webpack_public_path__ + "static/media/whatsap.da879bf4.ico";